import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
import { BaseBuilderWithNameTransform } from '../../../../../utils';

export function ListInputContent() {
  return (
    <>
      <BaseBuilderWithNameTransform rampName="InputLabelInfo" />
      <RampWithNameTransform rampName="InputListBase" />
      <BaseBuilderWithNameTransform rampName="InputFooter" />
    </>
  );
}
